import ShapeDrawingBrush from './ShapeDrawingBrush';
import StylusNote from './StylusNote';

// Stylus for creating an endless stack of notes
class StylusNoteStack extends StylusNote {
  activate() {
    super.activate();

    this.controller.canvas.freeDrawingBrush = new ShapeDrawingBrush(
      this.controller.canvas,
      this,
      { ...this.options, endlessStack: true }
    );
  }
}

export default StylusNoteStack;
